import React, { useState } from 'react';
import ComingSoonModal from './ComingSoonModal';

const Header: React.FC = () => {
  const [isComingSoonModalOpen, setIsComingSoonModalOpen] = useState(false);

  return (
    <>
      {/* Navigation - Floating pill style */}
      <nav className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-6 pt-3">
        <div className="max-w-md sm:max-w-lg mx-auto bg-white/80 backdrop-blur-xl rounded-2xl shadow-lg border border-gray-200/60 px-4 py-2.5 flex items-center justify-between">
          {/* Left: Logo + App Name */}
          <a href="/" className="flex items-center gap-2.5 hover:opacity-80 transition-opacity">
            <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 shadow-sm border border-gray-100">
              <img
                src="/branding/app-icon.png"
                alt="Hole In 1 Logo"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-bold text-lg text-gray-900">Hole In 1</span>
          </a>

          {/* Right: App Store button */}
          <button
            onClick={() => setIsComingSoonModalOpen(true)}
            className="hover:opacity-80 transition-opacity flex-shrink-0 w-8 h-8 bg-gray-200 rounded-lg flex items-center justify-center"
            aria-label="Download on the App Store"
          >
            <img
              src="/branding/app-store-icon.svg"
              alt="App Store"
              className="w-5 h-5"
            />
          </button>
        </div>
      </nav>

      {/* Coming Soon Modal */}
      <ComingSoonModal
        isOpen={isComingSoonModalOpen}
        onClose={() => setIsComingSoonModalOpen(false)}
      />
    </>
  );
};

export default Header;
